import { Modal } from '@mantine/core';
import { useEffect } from 'react';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { SectionDraftsModalBody } from './SectionDraftsModalContent';
import { useMeetingAgendaDrafts } from './useMeetingAgendaDrafts';

type MeetingAgendaDraftsModalProps = {
  meetingAgendaId: string | null;
  companyId: string;
  onClose: () => void;
};

export function MeetingAgendaDraftsModal({
  meetingAgendaId,
  companyId,
  onClose,
}: MeetingAgendaDraftsModalProps) {
  const { data, isLoading, isError, error } = useMeetingAgendaDrafts(companyId, meetingAgendaId);

  useEffect(() => {
    if (isError) {
      notifyAndLogError(
        'Failed to load section drafts',
        'Could not fetch section drafts for this meeting agenda.',
        error,
        { meetingAgendaId },
      );
    }
  }, [isError, error, meetingAgendaId]);

  return (
    <Modal
      opened={!!meetingAgendaId}
      onClose={onClose}
      title={`Meeting agenda: ${meetingAgendaId ?? ''}`}
      size={1200}
    >
      <SectionDraftsModalBody
        drafts={data?.drafts}
        isLoading={isLoading}
        isError={isError}
        adviceJourneyInput={data?.adviceJourneyInput}
      />
    </Modal>
  );
}
